<template>
  <div class="header-container">
    <div class="header" v-if="$route.name!='Login'">
      <div class="area">
        <div class="item">
          <img src="../../assets/home/bottom_icon02.png">
          <div>官方品质保障</div>
        </div>
        <div class="item">
          <img src="../../assets/home/bottom_icon04.png">
          <div>客户式服务</div>
        </div>
        <div class="item">
          <img src="../../assets/home/bottom_icon03.png">
          <div>个性化定制服务</div>
        </div>
        <div class="item">
          <img src="../../assets/home/bottom_icon01.png">
          <div>班主任</div>
        </div>
        <div class="item">
          <img src="../../assets/home/bottom_icon05.png">
          <div>新课抢先听</div>
        </div>
      </div>
    </div>
    <div class="n-footer" v-if="$route.name!='Login'">
      <div class="area">
        <div class="list" v-for="(item) in list" :key="item.name">
          <div class="title">
            {{item.title}}
          </div>
          <div class="item" @click="entryClick(el,item,i)" v-for="(el,i) in item.links" :key="el.name">
            {{el.name}}
          </div>

        </div>
        <div class="list" v-for="(item,index) in linksList" :key="index">
          <div class="title">
            {{item.name}}
          </div>
          <div class="item" @click="entry(el,item)" v-for="(el,i) in item.children" :key="i">
            {{el.name}}
          </div>
        </div>
        <div class="list">
          <div class="title">中盛考研微信</div>
          <img :src="site_info.wechat_qrcode">
        </div>
        <div class="list">
          <div class="title">中盛考研APP</div>
          <img :src="site_info.app_qrcode">
        </div>
        <div class="list">
          <div class="title">全国统一客服电话</div>
          <div class="tel">{{site_info.registration_hotline}}</div>
          <div class="btn">
            <img src="../../assets/home/chat.png">
            <div>在线咨询>></div>
          </div>
          <div class="btn">
            <img src="../../assets/home/email.png">
            <div>投诉建议>></div>
          </div>
        </div>
      </div>
    </div>
    <div class="copyright" v-if="site_info">
      <div class="text">京公网安备
        {{site_info.gongwangbeian}} {{site_info.beian}}
        <span>
          <a target="blank" href="https://beian.miit.gov.cn/">中盛润德营业执照</a>
          <a target="blank"
            :href="'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode='+site_info.gongwangbeian">中盛润德ICP许可证</a></span>
      </div>
      <div class="text">版权所有：{{site_info.company_name}}｜地址：{{site_info.company_address}}</div>
      <!-- <img v-if="$route.name!='Login'" src="../../assets/home/Group10.png"> -->
    </div>
    <!-- <div class="footer">
      <div class="inner">
        <div class="footer_top">
          <router-link to="/" class="logo"><img src="@/assets/footer_logo.png" alt="" /></router-link>
          <div class="menu_box">
            <div class="item" v-for="(item, index) in linkList" :key="item.id">
              <a href="javascript:;" @click="entry(item.url, index)" class="title">{{ item.title }}</a>
              <div class="sub_menu">
                <div class="sub_item" v-for="(el, i) in item.two_linkList" :key="el.id">
                  <a href="javascript:;" @click="entry(el.url, index, el.child, i, el, item)">{{ el.name }}</a>
                </div>
              </div>
            </div>
          </div>
          <div class="contact">
            <div class="item">
              全国统一报名专线：
              <span>{{ site_info.registration_hotline }}</span>
            </div>
            <div class="item">
              客服电话：
              <span>{{ site_info.consumer_hotline }}</span>
            </div>
          </div>
        </div>
        <div class="copy_box">
          <div class="copy">
            {{ site_info.company_name }}
            <a target="blank"
              :href="'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode='+site_info.gongwangbeian">
              <img src="@/assets/police-icon.png" alt="京公网安备" style="margin-right:5px;margin-left:10px;">
              <span>京公网安备</span>
              <span>{{site_info.gongwangbeian}}</span>
            </a>
            <a target="blank" href="https://beian.miit.gov.cn/">{{ beian }}</a>
            {{ site_info.address }}
          </div>
        </div>
      </div>
    </div> -->
  </div>

</template>

<script>
export default {
  name: 'footerMenu',
  inject: ['reload'],
  data () {
    return {
      site_info: {},
      linksList: [],
      list: [{
        id: 1,
        title: '关于中盛',
        url: '/concerning',
        links: [{
          id: 502,
          name: '关于中盛',
          url: '/concerning'
        },
        {
          id: 2,
          name: '中盛资讯',
          url: '/info'
        },

        {
          id: 4,
          name: '讲师招聘',
          url: '/joinUs'
        }
        ]
      },
      {
        id: 4,
        title: '特色服务',
        links: [{
          id: 1,
          name: '在线班主任',
          url: '/user',
          child: 'myTeachers'
        },
          // {
          //   id: 2,
          //   name: '重读申请',
          //   url: '/guide'
          // },
        {
          id: 3,
          name: '在线答疑',
          url: '/user',
          child: 'myAnswering'
        }
          // {
          //   id: 4,
          //   name: '招募在校研究生',
          //   url: '/guide'
          // }
        ]
      }
      ],
      linkList: [{
        id: 1,
        title: '首页',
        url: '/',
        two_linkList: [{
          id: 101,
          name: '专业团队',
          url: '/?id=discipline',
          aurl: 'discipline'
        },
          // {
          //   id:102,
          //   name:'免费体验',
          //   url:'/?id=experience'
          // },
        {
          id: 103,
          name: '精选课程',
          url: '/?id=elaborately',
          aurl: 'elaborately'
        },
        {
          id: 104,
          name: '免费优选课',
          url: '/?id=optimization',
          aurl: 'optimization'
        },
        {
          id: 105,
          name: '六大优势',
          url: '/?id=goodness',
          aurl: 'goodness'
        },
        {
          id: 106,
          name: '教师团队',
          url: '/?id=teacher',
          aurl: 'teacher'
        }
        ]
      },
      {
        id: 2,
        title: '选课中心',
        url: '/lesson',
        two_linkList: [{
          id: 4,
          name: '基础系统班',
          url: '/lesson'
        },
        {
          id: 2,
          name: '钻石精讲班',
          url: '/lesson'
        },
        {
          id: 3,
          name: '超钻密训班',
          url: '/lesson'
        },
        {
          id: 1,
          name: '提前面试班',
          url: '/lesson'
        },
        {
          id: 5,
          name: '私密1对1',
          url: '/lesson'
        }
        ]
      },
      {
        id: 3,
        title: '了解考研',
        url: '/learn',
        two_linkList: [{
          id: 301,
          name: '报考简章',
          url: '/learn'
        },
        {
          id: 302,
          name: '报考条件',
          url: '/learn'
        },
        {
          id: 303,
          name: '考研流程',
          url: '/learn'
        },
        {
          id: 304,
          name: '报名时间',
          url: '/learn'
        },
        {
          id: 305,
          name: '考试时间',
          url: '/learn'
        },
        {
          id: 306,
          name: '考试科目',
          url: '/learn'
        },
        {
          id: 307,
          name: '考研调剂',
          url: '/learn'
        }
        ]
      },
      {
        id: 4,
        title: '中盛资讯',
        url: '/info',
        two_linkList: [{
          id: 401,
          name: '公司资讯',
          url: '/info'
        },
        {
          id: 402,
          name: '考研资讯',
          url: '/info'
        }
        ]
      },
      {
        id: 5,
        title: '关于中盛',
        url: '/concerning',
        two_linkList: [{
          id: 501,
          name: '专业团队',
          url: '/concerning'
        },
        {
          id: 502,
          name: '企业文化',
          url: '/concerning'
        },
        {
          id: 503,
          name: '联系我们',
          url: '/concerning'
        },
        {
          id: 504,
          name: '法律声明',
          url: '/concerning'
        }
        ]
      },
      {
        id: 6,
        title: '个人中心',
        url: '/user',
        two_linkList: [{
          id: 601,
          name: '我的课程',
          url: '/user',
          child: 'myLesson'
        },
        {
          id: 602,
          name: '我的班主任',
          url: '/user',
          child: 'myTeachers'
        },
        {
          id: 603,
          name: '我的订单',
          url: '/user',
          child: 'myOrder'
        },
        {
          id: 604,
          name: '在线答疑',
          url: '/user',
          child: 'myAnswering'
        },
        {
          id: 605,
          name: '个人资料',
          url: '/user',
          child: 'myInfo'
        },
        {
          id: 606,
          name: '修改密码',
          url: '/user',
          child: 'myPassword'
        }
        ]
      }
      ]
    }
  },
  methods: {
    // 公共配置
    getConfig () {
      this.get('pc/config/info', false).then((res) => {
        this.site_info = res.data
      })
    },
    // 常见问题
    getCategory () {
      this.get('pc/qa/category', true).then((res) => {
        this.linksList = res.data
      })
    },
    entryClick (item, fitem, childIndex) {
      if (fitem.id === 4) {
        let routeUrl = this.$router.resolve({
          path: '/user',
          query: {
            childpath: item.child,
            navindex: childIndex,
            id: item.id,
            aurl: item.url
          }
        })
        window.open(routeUrl.href, '_blank')
      } else if (fitem.id === 1) {
        this.$router.push({
          path: item.url
        })
      }
      sessionStorage.setItem('navId', item.id)
    },
    entry (item, fitem) {
      this.$router.push({
        path: '/guide',
        query: {
          name: fitem.name,
          id: item.id
        }
      })
      this.reload()
    }
  },
  mounted () {
    this.getCategory()
    this.getConfig()
    // this.get('v2023/question/category', true).then((res) => {
    //   this.linksList = res.data
    // })
    // this.get('course/category',false).then(res => {
    //   this.linkList.forEach((e,i) => {
    //     if (e.id == 2) {
    //       e.two_linkList.forEach((v,j) => {
    //         v.name=res.data[j].name
    //         v.url=`/lesson?id=${res.data[j].id}`
    //       })
    //     }
    //   })
    // });
    // this.get('article/category',false).then(res => {
    //   this.linkList.forEach((e,i) => {
    //     if (e.id == 4) {
    //       e.two_linkList.forEach((v,j) => {
    //         v.name=res.data[j].name
    //         v.url=`/info?id=${res.data[j].id}`
    //       })
    //     }
    //   })
    // });
  }
}
</script>

<style lang="scss" scoped="scoped">
  .header-container {
    .header {
      background: #F6F6F6;

      .area {
        max-width: 1200px;
        height: 72px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 0 auto;

        .item {
          display: flex;
          align-items: center;
          font-size: 17px;
          font-weight: 500;
          color: #222222;

          img {
            width: 28px;
            height: 28px;
            margin-right: 10px;
          }
        }
      }

    }

    .n-footer {
      background: #fff;

      .area {
        max-width: 1200px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        padding-top: 36px;
        padding-bottom: 25px;

        .list {
          background: #fff;
          img{
            width: 110px;
          }
          .title {
            font-size: 16px;
            font-weight: 500;
            color: #222222;
            margin-bottom: 11px;
            text-align: center;
          }

          .item {
            margin-bottom: 12px;
            font-size: 14px;
            font-weight: 400;
            color: #555555;
            cursor: pointer;
            text-align: center;
          }

          .tel {
            font-size: 20px;
            font-weight: 500;
            color: #4EAAFF;
          }

          .btn {
            text-align: center;
            width: 134px;
            line-height: 32px;
            background: #F6F6F6;
            border-radius: 6px 6px 6px 6px;
            border: 1px solid #D1D1D1;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0 auto;
            margin-top: 10px;

            
            img {
              width: 18px;
              height: 18px;
              margin-right: 10px;
            }
          }
        }
      }
    }

    .copyright {
      padding: 34px 0 30px;
      text-align: center;

      .text {
        font-size: 14px;
        font-weight: 400;
        color: #8C8C8C;
        line-height: 1.6;

        span {
          color: #4E80FF;
        }
      }

      img {
        margin-top: 10px;
      }
    }
  }
    @media screen and (max-width:480px) {
      .header-container{
        display: none;
      }
    }

</style>



// WEBPACK FOOTER //
// src/layout/components/footerMenu.vue